export default function Button({ text, action, onClick, className = "", disabled = false }) {
    const handleClick = () => {
        if (!disabled && onClick) {
            onClick(action);
        }
    };

    return (
        <button onClick={handleClick} disabled={disabled} className={`py-2 md:py-3 px-3 md:px-4 rounded-xl transition-all duration-300 ease-in-out 
                ${disabled
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-main text-white hover:bg-main-dark"
            } ${className}`}>
            {text}
        </button>
    );
}
